export default __webpack_public_path__ + "static/media/camera-active.b4cbda0a.svg";